import {colors} from '@commercial-helios/ui/theme'

export type BackgroundColor = keyof typeof colors.background

export const isValidBackgroundColor = (value: string): value is BackgroundColor =>
    Object.keys(colors.background).includes(value)
